import { useEffect, useState } from "react";
import SlidingPanel from "./SlidingPanel";

interface LogoutSlidingPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onClickConfirm: () => void;
  sliderHeading?: string;
}

const LogoutSlidingPanel = ({
  isOpen,
  onClose,
  onClickConfirm,
  sliderHeading = "",
}: LogoutSlidingPanelProps) => {
  const [countdown, setCountdown] = useState<number>(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={sliderHeading}
      onClose={() => {
        onClose();
      }}
    >
      <div className="flex flex-col px-[16px] pb-[16px] pt-[8px]">
        <div className="flex flex-col">
          <div className="flex flex-col justify-center items-center  space-y-[16px]">
            <div className="text-text-base text-[14px] font-normal">
              Are you sure you want to logout?
            </div>
            <button
              className="flex items-center justify-center border-solid border-[1px] border-border-button rounded-md w-full py-[6px] mb-[12px] cursor-pointer"
              onClick={() => {
                onClickConfirm();
              }}
            >
              <span className="material-symbols-outlined pr-[8px] font-medium text-[22px] leading-none">
                logout
              </span>
              <span className="text-[14px] font-semibold">LOGOUT</span>
            </button>

            <button
              className="text-[14px] font-semibold cursor-pointer"
              onClick={() => {
                onClose();
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </SlidingPanel>
  );
};

export default LogoutSlidingPanel;
